"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var FormComponent_1 = require("@/pages/common/components/FormComponent");
var Validator_1 = require("@/utils/Validator");
var WindowApi_1 = require("@/api/browser/WindowApi");
var LoginFormComponent = /** @class */ (function (_super) {
    __extends(LoginFormComponent, _super);
    function LoginFormComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onBlurHandlers = {
            email: _this.onBlurHandler('email', [Validator_1.required, Validator_1.email]),
            password: _this.onBlurHandler('password', [Validator_1.required]),
        };
        return _this;
    }
    LoginFormComponent.prototype.render = function () {
        var _a = this.state, form = _a.form, tForm = _a.tForm, ui = _a.ui;
        var buttonClass = "o-btn o-btn--primary o-btn--long " + (ui.isLoading ? 'o-btn--loading' : '');
        var pwFieldClass = classnames_1.default([
            'c-forms__field',
            {
                'c-forms__field--disabled': ui.isLoading,
            },
        ]);
        var emailFieldClass = classnames_1.default([
            'c-forms__field',
            {
                'c-forms__field--disabled': ui.email || ui.isLoading,
            },
        ]);
        var emailDisabled = function () {
            return ui.email || ui.isLoading ? { disabled: true } : {};
        };
        return (React.createElement("div", { className: "c-login__login" },
            React.createElement("form", { className: "c-forms", id: "login-form-component", onSubmit: this.onSubmitHandler() },
                this.renderErrors(),
                React.createElement("div", { className: "c-forms__row" },
                    React.createElement("div", { className: "c-forms__cols" },
                        React.createElement("div", { className: "c-forms__col" },
                            React.createElement("div", { className: "c-forms__fields" },
                                React.createElement("div", { className: emailFieldClass },
                                    React.createElement("input", __assign({ id: "loginInputEmail", type: "email", className: "c-forms__input", placeholder: tForm.email, value: form.email, disabled: ui.isLoading, onChange: this.onChangeHandler('email'), onBlur: this.onBlurHandlers.email }, emailDisabled())))))),
                    this.renderError('email')),
                React.createElement("div", { className: "c-forms__row" },
                    React.createElement("div", { className: "c-forms__cols" },
                        React.createElement("div", { className: "c-forms__col" },
                            React.createElement("div", { className: "c-forms__fields" },
                                React.createElement("div", { className: pwFieldClass },
                                    React.createElement("input", { id: "loginInputPass", type: "password", className: "c-forms__input", placeholder: tForm.password, value: form.password, disabled: ui.isLoading, onChange: this.onChangeHandler('password'), onBlur: this.onBlurHandlers.password }))))),
                    this.renderError('password')),
                React.createElement("div", { className: "c-forms__row" },
                    React.createElement("div", { className: "c-forms__cols" },
                        React.createElement("div", { className: "c-forms__col" },
                            React.createElement("div", { className: "c-forms__checkboxs" },
                                React.createElement("div", { className: "c-forms__checkbox" },
                                    React.createElement("input", { id: "loginRememberMe", type: "checkbox", checked: form.rememberMe, onChange: this.onChangeHandler('rememberMe') }),
                                    React.createElement("label", { htmlFor: "remember" }, tForm.rememberMe)))),
                        React.createElement("div", { className: "c-forms__col", style: { alignItems: 'flex-end' } },
                            React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + ui.lang + "/account/forgotpassword"), className: "o-btn o-btn--flat" }, tForm.forgetPassword)))),
                React.createElement("div", { className: "c-forms__row" },
                    React.createElement("div", { className: "c-forms__col c-forms__col--range" },
                        React.createElement("button", { className: buttonClass, disabled: ui.isLoading, id: "login-button", type: "submit" }, ui.isLoading ? '' : tForm.submit))))));
    };
    return LoginFormComponent;
}(FormComponent_1.default));
exports.default = LoginFormComponent;
